import { Link } from "@tanstack/react-router";
import { MagnifyingGlass as Search, X } from "@phosphor-icons/react";
import { useRef, useState } from "react";
import { Logomark } from "@/components/brand/Logomark";
import { IconButton } from "@/components/ui/IconButton";
import { SearchInput } from "@/components/ui/SearchInput";
import { ViewerMenu } from "./ViewerMenu";

/** Shown below 1280px (alongside the icon rail or bottom tab bar). */
export function TopBar() {
  const [searchOpen, setSearchOpen] = useState(false);
  const triggerRef = useRef<HTMLButtonElement>(null);
  const searchRef = useRef<HTMLInputElement>(null);
  const closeSearch = () => { setSearchOpen(false); requestAnimationFrame(() => triggerRef.current?.focus()); };
  return (
    <>
      <header className="flex h-14 shrink-0 items-center gap-2 border-b border-border bg-surface-1 px-4 xl:hidden">
        <Link to="/feed" aria-label="Studside home" className="shrink-0 md:hidden"><Logomark /></Link>
        <div className="hidden max-w-sm flex-1 sm:block" data-testid="inline-search">
          <SearchInput />
        </div>
        <div className="flex-1 sm:hidden" />
        <IconButton ref={triggerRef} label="Search" icon={<Search size={18} />} className="sm:hidden" onClick={() => { setSearchOpen(true); requestAnimationFrame(() => searchRef.current?.focus()); }} />
        <ViewerMenu size="md" compact />
      </header>
      {searchOpen && <div className="flex items-center gap-2 border-b border-border bg-surface-1 px-4 py-2 sm:hidden">
        <SearchInput ref={searchRef} autoFocus className="min-w-0 flex-1" onKeyDown={(event) => { if (event.key === "Escape") closeSearch(); }} />
        <IconButton label="Close search" icon={<X size={18} />} onClick={closeSearch} />
      </div>}
    </>
  );
}
